import { atom } from "jotai";
export const consultasAtom = atom([]);
export const visibleModalConsultaAtom = atom(false);
export const visibleModalVerConsultaAtom = atom(false);
export const consultaSeleccionadaAtom = atom(undefined);
export const detalleConsultaAtom = atom([]);
export const numeroRespuestasAtom = atom([]);
export const totalRespuestasUsuarioAtom = atom(0);